import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { translations, type Lang, type Translation } from "@/i18n/translations";

type Ctx = { lang: Lang; setLang: (l: Lang) => void; t: Translation };

const LanguageContext = createContext<Ctx | null>(null);

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const [lang, setLang] = useState<Lang>(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("plays_lang") : null;
    return saved === "pt" || saved === "en" ? saved : "en";
  });
  useEffect(() => {
    localStorage.setItem("plays_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
